import Vue from 'vue';
import gql from 'graphql-tag';

let authenticationPromise;

Vue.localStorage.authToken = {
    type: String,
    default: ''
};

Vue.localStorage.refreshToken = {
    type: String,
    default: ''
};

export default {
    namespaced: true,
    state() {
        let authToken = Vue.localStorage.get('authToken');
        let refreshToken = Vue.localStorage.get('refreshToken');

        return {
            showLoginModal: false,
            login: null,
            authToken: authToken,
            refreshToken: refreshToken,
            thirdPartyCookiesDisabled: false,
        };
    },
    getters: {
        authToken: state => state.authToken,
        refreshToken: state => state.refreshToken,
        isUserLoggedIn: state => {
            let result = false;
            if (state.authToken) {
                const base64Url = state.authToken.split('.')[1];
                const base64 = decodeURIComponent(atob(base64Url).split('').map((c) => {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                try {
                    const tokenData = JSON.parse(base64);
                    if (tokenData.customerId) {
                        result = true;
                    }
                } catch (err) {

                }
            }

            return result;
        }
    },
    mutations: {
        setShowLoginModal(state, value) {
            state.showLoginModal = value;
        },
        setAuthToken(state, value) {
            console.log('set_auth_token', value);
            if (value) {
                Vue.localStorage.set('authToken', value);
            } else {
                Vue.localStorage.remove('authToken');
            }
            state.authToken = value;
        },
        setLogin(state, value) {
            state.login = value;
        },
        setRefreshToken(state, value) {
            if (value) {
                Vue.localStorage.set('refreshToken', value);
            } else {
                Vue.localStorage.remove('refreshToken');
            }
            state.refreshToken = value;
        },
        setThirdPartyCookiesDisabled: (state, thirdPartyCookiesDisabled) => state.thirdPartyCookiesDisabled = thirdPartyCookiesDisabled,
    },
    actions: {
        authenticate({ commit, rootState }, payload) {
            if (!authenticationPromise) {
                authenticationPromise = Vue.$graphql
                    .mutate({
                        mutation: gql`
                            mutation($login: String, $password: String, $refreshToken: String, $authType: String) {
                                authenticate(login: $login, password: $password, refreshToken: $refreshToken, authType: $authType) {
                                    token
                                    refreshToken
                                }
                            }
                        `,
                        variables: payload,
                    })
                    .then(r => r.data.authenticate)
                    .then(authData => {
                        authenticationPromise = null;
                        commit('setLogin', payload.login);
                        commit('setAuthToken', authData.token);
                        commit('setRefreshToken', authData.refreshToken);
                    })
                    .catch(e => {
                        authenticationPromise = null;
                        throw e;
                    });
            }

            return authenticationPromise;
        },
        logout({ commit }) {
            commit('setAuthToken', null);
            commit('setRefreshToken', null);
        },
        resetPasswordRequest({}, options) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation($login: String!, $language: String!) {
                            resetPasswordRequest(login: $login, language: $language)
                        }
                    `,
                    variables: {
                        login: options.login,
                        language: Vue.$language.getLanguage()
                    },
                })
                .then(r => r.data.resetPasswordRequest);
        },
        changePassword({}, options) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation($password: String!, $language: String!, $token: String) {
                            changePassword(password: $password, language: $language, token: $token)
                        }
                    `,
                    variables: {
                        password: options.password,
                        token: options.token,
                        language: Vue.$language.getLanguage()
                    },
                })
                .then(r => r.data.changePassword);
        },
        refreshAuthToken({state, dispatch}) {
            if (state.refreshToken) {
                return dispatch('authenticate', {
                    refreshToken: state.refreshToken,
                })
                    .catch(e => {
                        dispatch('logout');
                    });
            } else {
                return new Promise((resolve, reject) => reject());
            }
        },
    }
};
